import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';

type Align = 'start' | 'end' | 'between';

const ALIGN_CLASSES: Record<Align, string> = {
  start: 'justify-start',
  end: 'justify-end',
  between: 'justify-between',
};

@Component({
  selector: 'app-responsive-modal-actions',
  standalone: true,
  imports: [CommonModule, MatDialogModule],
  // Layout-transparent: see header component for rationale. With
  // `display: contents`, the inner mat-dialog-actions becomes effectively a
  // direct flex child of the user's dialog component host, so the global
  // `.responsive-modal .mat-mdc-dialog-actions { flex-shrink: 0 }` rule
  // keeps the actions row pinned at the bottom.
  styles: [`:host { display: contents; }`],
  template: `
    <mat-dialog-actions
      class="flex items-center gap-2 px-2 py-3 md:px-4 md:py-4 border-t"
      [class]="alignClass()"
    >
      <ng-content />
    </mat-dialog-actions>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResponsiveModalActionsComponent {
  readonly align = input<Align>('end');
  readonly alignClass = computed(() => ALIGN_CLASSES[this.align()]);
}
